import { joinURL } from 'ufo'

export const useStatamicCsrf = () => {
    const getToken = () => {
        console.log('requesting csrf token')
        const apiUrl = joinURL(useRuntimeConfig().public.statamicUrl, '/api')

        return $fetch(joinURL(apiUrl, '/csrf-cookie'), {
            credentials: 'include',
        })
    }

    return {
        getToken,
    }
}
